import { Cookies } from 'react-cookie';

import { MCTDetailChartData } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getTrapDetailChartData = async (slug: string, type: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/v1/trap-activation-signals-standard-chart/${type}/${slug}/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as MCTDetailChartData[];
};
